import 
{
    GET_ALL_UNREAD_NOTIFICATIONS_DATA,
    GET_ALL_UNREAD_NOTIFICATIONS_LOADING,
    GET_ALL_UNREAD_NOTIFICATIONS_FAILED

} from "./actionTypes";

const INIT_STATE = {
    unread_notification_loading: false,
    unread_notification_data: [],
    unread_notification_error: true
}

const Notifications = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ALL_UNREAD_NOTIFICATIONS_DATA:
            return {
                ...state,
                unread_notification_data: action.payload,
                unread_notification_loading: false,
                unread_notification_error: false
            }
        case GET_ALL_UNREAD_NOTIFICATIONS_LOADING:
            return {
                ...state,
                unread_notification_loading: true,
                unread_notification_error: false,
                unread_notification_data: []
            }
        case GET_ALL_UNREAD_NOTIFICATIONS_FAILED:
            return {
                ...state,
                unread_notification_error: action.payload,
                unread_notification_loading: false,
                unread_notification_data: []
            }
        default:
            return { ...state } 
    }
}

export default Notifications;